function walkGameEventsObj(conf){
    PIXI.Container.call(this);
    var all_types_conf={
        
    };
    conf=$.extend(true,{
        pos:[0,0],
        xy:[0,0],
        type:"slow",//stop
        step_max:600,
        opacity_step_max:80,
        opacity_modulo:20,
        cell_size:10
    },conf);
    this.objArr=[];
    this.delta_sum=0;
    this.conf=conf;
    this.pos=copyArray(conf.pos);
    this.x=conf.xy[0];
    this.y=conf.xy[1];
    
    this.sizeR=this.conf.cell_size*this.conf.cell_size/4;
    
    this.back=new myPixiElement.img({img:"img_event_"+this.conf.type});
    
    this.addChild(this.back);
    
}
walkGameEventsObj.prototype = Object.create(PIXI.Container.prototype);
walkGameEventsObj.prototype=$.extend(walkGameEventsObj.prototype,{
    
    checkStand:function(pos,xy){
//        $.qLog(pos[0]+"_"+pos[1]+" ");
        if(Math.abs(pos[0]-this.pos[0])<=2 && Math.abs(pos[1]-this.pos[1])<=2 && lengthVectorPow(makeVector(xy,[this.x,this.y]))<=this.sizeR){
            this.alpha=0;
            this.delta_sum=this.conf.step_max+this.conf.opacity_step_max;
            return this.conf.type;
        }
        return "";
    },
    myUpdate:function(delta){
        this.delta_sum+=delta;
        if(this.delta_sum>this.conf.step_max){
            var step_opacity=this.delta_sum-this.conf.step_max;
            var alpha=1;
            if(step_opacity%this.conf.opacity_modulo<this.conf.opacity_modulo/2){
                alpha=0.3;
            }
            if(this.alpha!=alpha){
                this.alpha=alpha;
            }
            if(step_opacity>=this.conf.opacity_step_max){
                return 0;
            }
        }
        return 1;
        
    } 
});

function walkGameEvents(conf,mapObj){
    PIXI.Container.call(this);
    this.mapObj=mapObj;
    conf=$.extend(true,{
        event_arr:[],//"slow","stop"
        event_objs:{
            slow:{step_add:250},
            stop:{step_add:300}
        },
        step_need:100000
    },conf);
    this.step_add_sum=0;
    this.step_obj={};
    var i,name;
    for(i in conf.event_arr){
        name=conf.event_arr[i];
        this.step_add_sum+=conf.event_objs[name].step_add;
        this.step_obj[name]=conf.event_objs[name].step_add;
    }
    this.objArr=[];
    this.delta_sum=0;
    this.conf=conf;
}
walkGameEvents.prototype = Object.create(PIXI.Container.prototype);
walkGameEvents.prototype=$.extend(walkGameEvents.prototype,{
    addObj:function(){
        var type=this.conf.event_arr[mt_rand(0,this.conf.event_arr.length-1)];
        var seed=mt_rand(1,this.step_add_sum);
        var name,seed_sum=0;
        for(name in this.step_obj){
            seed_sum+=this.step_obj[name];
            if(seed<=seed_sum){
                type=name;
                break;
            }
        }
        var i=0,i_max=10;
        
        var map_size=this.mapObj.conf.size,pos;
        while(i<i_max){
            i++;
            pos=[mt_rand(1,map_size[0]-2),mt_rand(1,map_size[1]-2)];
            if(this.mapObj.fields[pos[0]][pos[1]]=="d"){
                i=i_max;
            }
        }
        this.objArr.push(new walkGameEventsObj({
            pos:pos,
            xy:this.mapObj.takeXY(pos),
            type:type,
            cell_size:this.mapObj.conf.cell_size
        }));
        
        this.addChild(this.objArr[this.objArr.length-1]);
        return true;
    },
    checkWithPath:function(pos_obj){
        var i,pos_obj,k,len=this.objArr,val;
        if(len==0){
            return [];
        }
        var ready=[];
        for(k in this.objArr){
            val=this.objArr[k].checkStand(pos_obj.pos,pos_obj.xy);
            if(val!=""){
                ready.push(val);
            }
        }
        return ready;
    },
    myUpdate:function(delta){
        if(this.conf.event_arr.length==0){
            return false;
        }
        this.delta_sum+=delta*this.step_add_sum;
        
        var i,len=this.objArr.length,obj;
        for(i=len-1;i>=0;i--){
            obj=this.objArr[i];
            if(!obj.myUpdate(delta)){
                obj.destroy();
                this.objArr.splice(i,1);
            }
        }
        //step_need
        if(this.delta_sum>=this.conf.step_need){
            this.delta_sum-=this.conf.step_need;
            this.addObj();
        }
        
    } 
});